/**递归查询类目 */
export const deepFilterCategoryItem = (
  data: SwaggerDTO.ProductConfigSpuInfoDTO[],
  code
): SwaggerDTO.ProductConfigSpuInfoDTO | undefined => {
  let item: SwaggerDTO.ProductConfigSpuInfoDTO | undefined = undefined

  data?.forEach(product => {
    if (product.productCode === code) {
      item = product
    } else {
      let childItem = deepFilterCategoryItem(product?.childList, code)
      childItem && (item = childItem)
    }
  })
  return item
}

/**请求是order字段枚举 */
export const requestOrderEnums = {
  0: [],
  /**售价升序 */
  1: ['PRICE_ASC'],
  /**售价降序 */
  2: ['PRICE_DESC'],
}

export const deepFindCategoryChildren = (
  data: SwaggerDTO.ProductConfigSpuInfoDTO[]
) => {
  let items: SwaggerDTO.ProductConfigSpuInfoDTO[] = []

  data?.forEach(product => {
    if (product?.childList?.length) {
      items.push(...deepFindCategoryChildren(product.childList))
    } else {
      items.push(product)
    }
  })
  return items
}
